export default __webpack_public_path__ + "static/media/screenShots_fund-2.41f100e4.jpg";